import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetInstructionDetailsAsync,
  IInstructionDetails,
} from "../../api/Instruction";
import { RootState } from "../store";

export interface InstructionState {
  fetchStatus: string;
  instruction?: IInstructionDetails;
}

const initialState: InstructionState = {
  fetchStatus: "Loading...",
  instruction: undefined,
};

export const loadInstructionAsync = createAsyncThunk(
  "instruction/load",
  async (instructionId: string) => {
    const response = await GetInstructionDetailsAsync(instructionId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const instructionSlice = createSlice({
  name: "instruction",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadInstructionAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadInstructionAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.instruction = action.payload;
      });
  },
});

export const selectInstruction = (state: RootState) => state.instruction;

export default instructionSlice.reducer;
